import {
  useCreateProjectGroupsItemSheetFinalized,
  useDeleteProjectGroupsItemSheetFinalized,
  useDeleteProjectGroupsItemSheetLatest,
  useDuplicateProjectGroupsItemSheetLatest,
} from "@/libs/react-query/hooks/useItemsheetsQuery";
import { showToast } from "@/utils/toastUtils";
import { useSelectedProjectInfo } from "./useTabStore";
import { useParams } from "react-router-dom";

type Props = {
  closePopover: () => void;
};

export function useEstimateActions({ closePopover }: Props) {
  const { group_id = "" } = useParams();

  const selectedProjectInfo = useSelectedProjectInfo();

  const { mutate: deleteEstimate } =
    useDeleteProjectGroupsItemSheetLatest(group_id);
  const { mutate: copyEstimate } =
    useDuplicateProjectGroupsItemSheetLatest(group_id);
  const { mutate: createFinalizedEstimate } =
    useCreateProjectGroupsItemSheetFinalized(group_id);
  const { mutate: deleteFinalizedEstimate } =
    useDeleteProjectGroupsItemSheetFinalized(group_id);

  const handleConfirm = (latestSheetId: string, is_finalized: boolean) => {
    if (!selectedProjectInfo) return;

    const { projectType, originalId } = selectedProjectInfo;

    if (is_finalized) {
      deleteFinalizedEstimate(
        { project_type: projectType },
        {
          onSuccess: () => showToast({ message: "확정 해제되었습니다." }),
        }
      );
    } else {
      createFinalizedEstimate(
        {
          project_type: projectType,
          latest_id: latestSheetId,
          original_id: originalId,
        },
        {
          onSuccess: () => showToast({ message: "확정되었습니다." }),
        }
      );
    }
    closePopover();
  };

  const handleCopy = (latestSheetId: string) => {
    if (!selectedProjectInfo) return;
    const { projectId, projectType, originalId } = selectedProjectInfo;

    copyEstimate(
      {
        latest_sheet_id: latestSheetId,
        data: {
          project_id: projectId,
          project_type: projectType,
          original_id: originalId,
        },
      },
      {
        onSuccess: () => showToast({ message: "복제되었습니다." }),
      }
    );
    closePopover();
  };

  const handleDelete = (latestSheetId: string) => {
    if (!selectedProjectInfo) return;
    const { projectId, projectType, originalId } = selectedProjectInfo;

    deleteEstimate(
      {
        latest_sheet_id: latestSheetId,
        data: {
          project_id: projectId,
          project_type: projectType,
          original_id: originalId,
        },
      },
      {
        onSuccess: () => showToast({ message: "삭제되었습니다." }),
      }
    );
    closePopover();
  };

  return { handleConfirm, handleCopy, handleDelete };
}
